
// 图片上传弹窗
Vue.component("upload_picture_modal", {
  props: {
  },
  data() {
    return {
      visible: false,
      loading: false,
      path: ''
    };
  },
  methods: {
    open() {
      this.visible = true
    },
    uploadSuccess(res, file) {
      if (res.status == 200) {
        let path = res.data.httpPath
        this.$emit('search', path)
        this.visible = false
      } else {
        if (!this.path) return this.$message.error(this.$t('上传失败！'))
      }
    },
    handleSearch() {
      if (!this.path) return this.$message.info(this.$t('请输入链接'))
      this.$emit('search', this.path)
      this.visible = false
    },
    beforeUpload(){
      this.loading = true
    },
    onProgress(event){
      if(event.percent == 100){
        this.loading = false
      }
    },
    beforeUpload(file){
      if(file.type != 'image/jpeg' && file.type != 'image/png'){
        this.$message.warning(this.$t('暂不支持该格式图片检索，请重新上传'))
        return false
      }
    }
  },
  template: `
      <el-dialog title="以图搜图" :visible.sync="visible" class="upload_picture_modal" :modal="false" @closed="path = ''">
        <el-upload
          drag
          action="/learn/v1/upload/fileupload"
          :show-file-list="false"
          :before-upload="beforeUpload"
          v-loading="loading"
          :on-progress="onProgress"
          :on-success="uploadSuccess"
          :before-upload="beforeUpload"
          accept="image/png, image/jpeg">
          <div class="upload_text"><img src="/learn/static/imgs/teaching_resource/drag_drop_illustration.svg"/><div>将图片放到此处或<span>上传文件</span></br><div>请上传jpg、png格式图片</div></div></div>
          <div class="split"><span>或</span></div>
          <div class="search_box" @click.stop="()=>{}">
            <el-input placeholder="请粘贴图片的链接" v-model="path"></el-input>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </div>
        </el-upload>
      </el-dialog>
  `,
});